interface HostBioProps {
  image: string;
  name: string;
  title: string;
  description: string;
}

export default function HostBio({ image, name, title, description }: HostBioProps) {
  return (
    <div className="flex-1 text-center group">
      <div className="relative w-56 h-56 mx-auto mb-6 overflow-hidden rounded-full transition-transform duration-300 ease-out group-hover:-translate-y-1">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-burgundy/10 mix-blend-multiply rounded-full" />
      </div>
      <h3 className="font-playfair text-stone-800 text-[31px] mb-1">
        {name}
      </h3>
      <p
        className="font-montserrat text-burgundy uppercase mb-4"
        style={{ fontSize: "14px", letterSpacing: "0.16em", fontWeight: 600 }}
      >
        {title}
      </p>
      <p className="font-montserrat text-stone-700 text-[18px] leading-relaxed max-w-sm mx-auto">
        {description.split("\n").map((line, i) => (
          <span key={i}>
            {line}
            {i < description.split("\n").length - 1 && <><br /><br /></>}
          </span>
        ))}
      </p>
    </div>
  );
}